export default __webpack_public_path__ + "static/media/glass_nano.c1d39a1a.JPG";